<template>
  <div>
    <div class="titel_NotificacionesRecientes">{{ $t("sidebar.saldos") }}</div>
    <div class="datos_NotificacionesRecientes">
      <PDataLine
        :value="notificacionSaldo"
        :fields="fieldsNotificacionesSaldos"
        v-for="(notificacionSaldo, index) in notificacionesSaldos"
        :key="index + 'notificacioneSaldo'"
        justifyContent="flex-start"
        :showTitle="true"
      >
        <template #title="data">
          <div class="containerTitleDatalien_NotificacionesRecientes">
            <div class="puto__NotificacionesRecientes"></div>
            <div>
              <div class="titleDataline_NotificacionesRecientes">
                {{ $t("label.asunto") }}
              </div>
              <div class="textDataline_NotificacionesRecientes">
                {{ data.data.asunto }}
              </div>
            </div>
          </div>
        </template>
        <template #actions>
          <div class="linkActions_NotificacionesRecientes" @click="showDetails">
            {{ $t("label.verDetalle") }}
          </div>
        </template>
      </PDataLine>
    </div>
    <div class="titel_NotificacionesRecientes">{{ $t("label.transferencias") }}</div>
    <div class="datos_NotificacionesRecientes">
      <PDataLine
        :value="notificacionTransferencia"
        :fields="fieldsNotificacionesTransaferencias"
        v-for="(notificacionTransferencia, index) in notificacionesTransaferencias"
        :key="index + 'notificacioneSaldo'"
        justifyContent="flex-start"
        :showTitle="true"
      >
        <template #title="data">
          <div class="containerTitleDatalien_NotificacionesRecientes">
            <div class="puto__NotificacionesRecientes"></div>
            <div>
              <div class="titleDataline_NotificacionesRecientes">
                {{ $t("label.asunto") }}
              </div>
              <div class="textDataline_NotificacionesRecientes">
                {{ data.data.asunto }}
              </div>
            </div>
          </div>
        </template>
        <template #actions>
          <div
            class="linkActions_NotificacionesRecientes"
            @click="reactivar(notificacionTransferencia)"
          >
            {{ $t("label.reactivar") }}
          </div>
          <div
            class="linkActions_NotificacionesRecientes"
            @click="showDetails(notificacionTransferencia)"
          >
            {{ $t("label.verDetalle") }}
          </div>
        </template>
      </PDataLine>
    </div>
    <PModal :show="verModal" @close="verModal = false" :closeClickExit="false" :title="titleModal">
      <NotificacionesDetalle v-if="verNotificacionesDetalle"></NotificacionesDetalle>
      <NotificacionesReactivar v-if="verNotificacionesReactivar"></NotificacionesReactivar>
    </PModal>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import NotificacionesDetalle from "./NotificacionesDetalle.vue";
import NotificacionesReactivar from "./NotificacionesReactivar.vue";

@Component({
  components: {
    NotificacionesDetalle,
    NotificacionesReactivar,
  },
})
export class NotificacionesRecientes extends Vue {
  verNotificacionesDetalle = false;
  verNotificacionesReactivar = false;
  titleModal = "";
  verModal = false;
  notificacionesSaldos = [
    {
      asunto: "Saldo cargado",
      saldoTotalCargado: "EUR 323.382,48",
      sucursal: "Mar de Plata",
    },
    {
      asunto: "Saldo cargado",
      saldoTotalCargado: "EUR 323.382,48",
      sucursal: "Mar de Plata",
    },
    {
      asunto: "Saldo cargado",
      saldoTotalCargado: "EUR 323.382,48",
      sucursal: "Mar de Plata",
    },
  ];
  fieldsNotificacionesSaldos = {
    saldoTotalCargado: { title: this.$t("label.saldo.total.cargado"), width: "150px" },
    sucursal: { title: this.$t("label.sucursal"), width: "150px", divider: true },
  };
  notificacionesTransaferencias = [
    {
      asunto: "Demanda rechazada",
      remitente: "Banco XXXX",
      denominacion: "B P100 BUEN USO",
      demandado: "1.000.000.00,00",
    },
    {
      asunto: "Oferta expirada",
      denominacion: "B P100 BUEN USO",
      ofertado: "1.000.000.00,00",
    },
    {
      asunto: "Demanda rechazada",
      remitente: "Banco XXXX",
      denominacion: "B P100 BUEN USO",
      ofertado: "1.000.000.00,00",
    },
  ];
  fieldsNotificacionesTransaferencias = {
    remitente: { title: this.$t("label.recientemente"), width: "30px", emptyShow: false },
    denominacion: {
      title: this.$t("notificaciones.denominacion"),
      width: "30px",
      divider: true,
      emptyShow: false,
    },
    demandado: {
      title: this.$t("notificaciones.demandado"),
      width: "30px",
      divider: true,
      emptyShow: false,
    },
    ofertado: {
      title: this.$t("notificaciones.ofertado"),
      width: "30px",
      divider: true,
      emptyShow: false,
    },
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/explicit-module-boundary-types
  showDetails(notificacion: any): void {
    this.verModal = true;
    this.titleModal = this.$t("notificaciones.detalle");
    this.verNotificacionesDetalle = true;
    this.verNotificacionesReactivar = false;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/explicit-module-boundary-types
  reactivar(notificacion: any): void {
    this.verModal = true;
    this.titleModal = this.$t("label.reactivar");
    this.verNotificacionesDetalle = false;
    this.verNotificacionesReactivar = true;
  }
}
export default NotificacionesRecientes;
</script>
<style scoped>
.titel_NotificacionesRecientes {
  font-weight: bold;
  color: #4c4c4c;
}
.datos_NotificacionesRecientes {
  padding: 2rem;
}
.containerTitleDatalien_NotificacionesRecientes {
  display: flex;
  align-items: center;
}
.puto__NotificacionesRecientes {
  width: 8px;
  height: 8px;
  background-color: #ff507c;
  border-radius: 100%;
  margin-left: -20px;
  margin-right: 30px;
}
.titleDataline_NotificacionesRecientes {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #979797;
}
.textDataline_NotificacionesRecientes {
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  color: #808080;
  white-space: nowrap;
}
.linkActions_NotificacionesRecientes {
  cursor: pointer;
  font-weight: 500;
  color: #d7b000;
  font-size: 14px;
  padding: 0 1rem;
}
</style>
